import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';

export default {
    name: 'education',

    data() {
        return {
            videos: [],
        };
    },

    components: {
        BaseLayout
    },

    methods: {
        /**
         * Get education videos from API
         */
        getVideos() {
            api.get('/api/promotions_active_education_videos')
                .then((response) => {
                    this.videos = response.data.body.videos;
                });
        },
    },

    watch: {
        'user.pcmsId': function (){
            this.getVideos();
        }
    },

    mounted() {
        this.getVideos();
    },
}